import {Renderer2, RendererStyleFlags2} from "@angular/core";

export class InputHighlightHelper {

  static update(renderer: Renderer2, el: HTMLInputElement | HTMLSelectElement) {
    const tag = el.tagName;

    let hasContent: boolean = false;
    if (tag === 'SELECT') {
      // const selectedEl = <HTMLSelectElement>el;
      // const selectedOption = selectedEl.options[selectedEl.selectedIndex];
      // hasContent = !selectedOption?.classList.contains('select-placeholder');
    } else {
      const value = el.value;
      hasContent = !!value && value.trim() !== '';
    }

    if (hasContent) {
      renderer.addClass(el, 'has-content-highlight');
    } else {
      renderer.removeClass(el, 'has-content-highlight');
    }
  }
}
